<template>
  <div class="new-subscribers-card w-100 mb-3 cursor-pointer" @click="$emit('click')">
    <div class="d-flex p-3 px-3 align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div class="icon-circle me-3">
          <i :class="['fa text-white', iconClass]"></i>
        </div>
        <div>
          <span class="text-white font-weight-600 font-size-15">{{ title }}</span>
          <div v-if="description" class="font-size-12 text-muted mt-1">{{ description }}</div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <i class="fa fa-chevron-right text-muted"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SleekNotificationCard",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'fa-bell'
    }
  }
}
</script>

<style scoped>
.new-subscribers-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.2s ease;
}
.new-subscribers-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}
.icon-circle {
  width: 40px; height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f5d165, #f565c5);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 15px rgba(245, 101, 197, 0.3);
}
</style>
